<template>
  <div class="custom-emoji-picker">
    <div class="emoji-grid">
      <div 
        v-for="(emoji,key) in customEmojis" 
        :key="emoji"
        class="emoji-item"
        :title="emoji"
        @click="insertCustomEmoji(key)"
      >
        <img 
          :src="getEmojiUrl(emoji)" 
          class="emoji-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import customEmojiConfig from './customEmojiConfig.json'

export default {
  data() {
    return {
      customEmojis: customEmojiConfig.customEmojis
    }
  },

  methods: {
    isMobileDevice() {
      return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    // 获取表情图片URL（线上部署时需配置正确的静态资源路径）
    getEmojiUrl(filename) {
      return `https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/kf/${filename}`
    },

    insertCustomEmoji(key) {
      const contentEditableElement = document.getElementById("content")
      if (!contentEditableElement) return
      
      // 使用配置中的表情符号
      this.insertTextAtCursor(key)
    },

    // 在光标位置插入文本
    insertTextAtCursor(text) {
     let contentEditableElement = document.getElementById("content");
    if (contentEditableElement) {
      // 获取所有的 <p> 标签
      let pTags = contentEditableElement.querySelectorAll('p');
      if (pTags.length > 0) {
        // 获取最后一个 <p> 标签
        let lastPTag = pTags[pTags.length - 1];
        // 如果最后一个 <p> 标签只包含 <br> 标签，则替换 <br> 标签
        if (lastPTag.innerHTML.trim() === '<br>') {
          lastPTag.innerHTML = text;
        } else {
          // 否则将表情插入到最后一个 <p> 标签的最后面
          lastPTag.innerHTML += text;
        }
      } else {
        // 如果没有 <p> 标签，则创建一个新的 <p> 标签并插入表情
        let newPTag = document.createElement('p');
        newPTag.innerHTML = text;
        contentEditableElement.appendChild(newPTag);
      }
    }
          
    
    },
  }
}
</script>

<style scoped>
.custom-emoji-picker {
	width: 100%;
	border-radius:0;
	height: 200px;
  overflow: auto;
  padding:20px 10px;
  box-sizing: border-box;
  background: #fff;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
}

.emoji-item {
  width: 28px;
  height: 28px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.emoji-item:hover {
  background-color: #f0f0f0;
}

.emoji-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>